
// Utils
import { moneyFormat } from '@/utils/functions'
import moment from 'moment'
import { dateHourFormat } from '@/filters'
import CONSTANTS from '@/utils/const'
import { object } from '@/utils/status'
import { mapGetters } from 'vuex'

// Components
import OrderStatusBar from '@/components/Orders/OrderStatusBar'
import AvatarInterface from '@/components/AvatarInterface'

const ON_SITE_COUNTDOWN = process.env.VUE_APP_ON_SITE_COUNTDOWN ? JSON.parse(process.env.VUE_APP_ON_SITE_COUNTDOWN) : false

const mixin = {
  components: {
    OrderStatusBar,
    AvatarInterface
  },
  props: {
    size: {
      type: String,
      default: () => '70px'
    },
    address: {
      type: [Object, String, Array],
      default: () => [{}, '', []]
    },
    folio: {
      type: String,
      default: () => '...'
    },
    currency: {
      type: String,
      default: () => 'MXN'
    },
    order: {
      type: Object,
      default: () => {}
    },
    total: {
      type: Number,
      default: () => 0.00
    },
    estimatedTime: {
      type: String,
      default: () => null
    },
    waPhone: {
      type: String,
      default: () => null
    }
  },
  data: () => ({
    isCountDown: false,
    timeoutReferece: null,
    isPageVisibility: true,
    countDown: {
      time: '',
      message: ''
    },
    ETAAlertIndicator: {
      estimatedTime: 0,
      message: ''
    },
    avatarDefault: CONSTANTS.AVATAR.DRIVER,
    url: CONSTANTS.URL.JELP_DELIVERY
  }),
  computed: {
    ...mapGetters(['wsCustom']),
    isETAAlerts() {
      return !this.isSiteAnimation && (this.order.customIndicators && this.order.customIndicators.isETAAlerts)
    },
    isCountDownValid() {
      return ON_SITE_COUNTDOWN > 0
    },
    isOnSiteCountDown() {
      return this.isCountDownValid && this.isSiteAnimation && this.isCountDown
    },
    isSiteAnimation() {
      return (this.order.customIndicators && this.order.customIndicators.onSiteAnimation)
    },
    driverPhoto() {
      return (this.order.deliveryMan && this.order.deliveryMan.photo) ? this.order.deliveryMan.photo : ''
    },
    totalAmount: function() {
      return moneyFormat(this.total)
    },
    fullAddress: function() {
      let _fullAddress = ''
      if (this.address && this.address.fullAddress) {
        _fullAddress = this.address.fullAddress.toLowerCase()
      } else {
        _fullAddress = this.address
      }
      return _fullAddress
    },
    shortAddress: function() {
      let address = this.address
      if (this.address && this.address.street && this.address.exteriorNumber && this.address.neighborhood) {
        const street = this.address.street ? ` ${this.address.street}` : ''
        const exteriorNumber = this.address.exteriorNumber ? ` ${this.address.exteriorNumber}` : ''
        const neighborhood = this.address.neighborhood ? `, ${this.address.neighborhood}` : ''
        address = `${street}${exteriorNumber}${neighborhood}`
      }
      return address
    },
    isEstimatedTime: function() {
      let _isValid = false
      if (this.estimatedTime && this.order.orderStep !== object.COMPLETED && this.order.orderStep !== object.ONSITE) {
        _isValid = true
      }
      return _isValid
    },
    getYear() {
      return new Date().getFullYear()
    },
    poweredBy() {
      return `Powered by Jelp Delivery © ${this.getYear}`
    },
    progressColor() {
      return this.wsCustom && this.wsCustom.progressColor
    },
    buttonColor() {
      let _buttonColor = '#243ac1'
      if (this.wsCustom && this.wsCustom.buttonColor) {
        _buttonColor = this.wsCustom.buttonColor
      }
      return _buttonColor
    }
  },
  methods: {
    visibilityChange: function(evt, isTabHidden) {
      this.isPageVisibility = !isTabHidden
      if (isTabHidden && this.timeoutReferece) {
        clearTimeout(this.timeoutReferece)
      }
    },
    onStartCountDownValidation: function() {
      if (this.isSiteAnimation) {
        let lastMovementDate = this.order.movements[this.order.movements.length - 1].createdAt
        const now = moment(new Date())
        lastMovementDate = moment(lastMovementDate)
        const lastMovementDifference = now.diff(lastMovementDate, 'minutes')
        let countDownStartValue = 0
        if (lastMovementDifference <= ON_SITE_COUNTDOWN) {
          countDownStartValue = ON_SITE_COUNTDOWN - lastMovementDifference
        }
        this.countdown(countDownStartValue, 0)
      }
    },
    countdown: function(minutes, seconds) {
      var endTime, hours, mins, msLeft, time
      var componentContext = this
      function twoDigitsFormat(n) {
        return (n <= 9 ? '0' + n : n)
      }
      function updateTimer() {
        msLeft = endTime - (+new Date())
        if (msLeft < 1000) {
          componentContext.countDown = {
            time: '00:00',
            message: componentContext.$t('general.waitTimeFinished')
          }
        } else {
          time = new Date(msLeft)
          hours = time.getUTCHours()
          mins = time.getUTCMinutes()
          componentContext.countDown = {
            time: (hours ? hours + ':' + twoDigitsFormat(mins) : mins) + ':' + twoDigitsFormat(time.getUTCSeconds()),
            message: componentContext.$t('general.waitTime')
          }
          componentContext.timeoutReferece = setTimeout(updateTimer, time.getUTCMilliseconds() + 500)
        }
      }
      endTime = (+new Date()) + 1000 * (60 * minutes + seconds) + 500
      if (!componentContext.isPageVisibility && componentContext.timeoutReferece) {
        clearTimeout(componentContext.timeoutReferece)
      } else {
        updateTimer()
      }
    },
    onViewStatus: function() {
      this.$emit('on-view-folio-status')
    },
    determineEstimatedTime: function() {
      let estimatedTime
      if (Array.isArray(this.order.ETAAlerts) && this.order.ETAAlerts.length > 0) {
        const ETAAlerts = this.order.ETAAlerts
        let controlPostion = ETAAlerts.length - 1
        let validEstimatedTime = false
        do {
          const lastETAlert = ETAAlerts[controlPostion]
          if (lastETAlert.estimatedTime) {
            estimatedTime = moment(lastETAlert.createdAt).add(lastETAlert.estimatedTime, 's').toDate()
            estimatedTime = dateHourFormat(estimatedTime)
            this.ETAAlertIndicator = lastETAlert
            validEstimatedTime = true
          } else {
            controlPostion--
          }
        } while (!validEstimatedTime && (controlPostion >= 0))
      }
      this.estimatedTime = estimatedTime
    }
  }
}

export default mixin
